module.exports = __webpack_public_path__ + "static/media/W5390484_24.f87d8ad4.jpg";